import querystring from 'querystring'
import ApiService from './ApiService'

const sustainabilityResourceUrl = `${ApiService.prefix}rest/data/sustainability`
const commentsResourceUrl = `${ApiService.prefix}rest/data/systemModule/comments`

export default {
  getQuestionnaireData(groupBy, excludeCampaigns, showCompletedData, showCalculatedMetrics) {
    const params = { groupBy, excludeCampaigns, showCompletedData, showCalculatedMetrics }
    return ApiService.get(
      `${sustainabilityResourceUrl}/questionnaire?${querystring.stringify(params)}`,
    )
  },
  _prepFormDataToSubmit(data) {
    const params = new URLSearchParams()
    params.append('sustainabilityMetric', data.sustainabilityMetric)
    params.append('metricInputType', data.metricInputType)
    params.append('timePeriod', data.timePeriod)
    params.append('location', data.location)
    params.append('inputValue', JSON.stringify(data.inputValue))
    params.append('commentsData', JSON.stringify(data.commentsData))
    return params
  },
  calculateFormula(data) {
    return ApiService.post(
      `${sustainabilityResourceUrl}/save/calculateFormula`,
      this._prepFormDataToSubmit(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  },
  calculate(data) {
    const bodyFormData = new URLSearchParams()
    bodyFormData.append('resultId', data.resultId)
    return ApiService.post(`${sustainabilityResourceUrl}/save/calculate`, bodyFormData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },
  save(data) {
    return ApiService.post(
      `${sustainabilityResourceUrl}/save/result`,
      this._prepFormDataToSubmit(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  },
  getPreviousGridData(item) {
    const params = {
      metricId: item.sustainabilityMetricId,
      periodId: item.timePeriodId,
      locationId: item.locationId,
    }
    return ApiService.get(`${sustainabilityResourceUrl}/inputs/previousGridData`, { params })
  },
  getExistingComments(parentId) {
    const params = {
      type: 'sustainability',
      parentId,
    }
    return ApiService.get(`${commentsResourceUrl}/existing`, { params })
  },
  postAddedComments(addedComments, parentId) {
    const params = new URLSearchParams()
    params.append('type', 'sustainability')
    params.append('parentId', parentId)
    params.append('commentsData', JSON.stringify(addedComments))

    return ApiService.post(`${commentsResourceUrl}/save`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
  },
}
